import { useSelector } from 'react-redux';

import { selectDailyrentOfferData } from 'shared/selectors/offerData/selectDailyrentOfferData';
import { useIsDailyrentOnlineBookingEnabled } from 'shared/utils/featureToggles/useIsDailyrentOnlineBookingEnabled';

export const useIsDailyrentOnlineBooking = (): boolean => {
  const dailyrent = useSelector(selectDailyrentOfferData);
  const isDailyrentOnlineBookingEnabled = useIsDailyrentOnlineBookingEnabled();

  return Boolean(isDailyrentOnlineBookingEnabled && dailyrent?.isOnlineBooking);
};
